/**
 * components/DayNav.js
 * Shared day navigator (‹ date › + Hari Ini + a manual date picker) — identical between
 * Penjualan and Pembelian (Phase T1c), each framing its list by transaction date.
 */
import React from "react";
import { today } from "../utils/idGenerators";

const shiftDay = (dateStr, delta) => {
  const d = new Date(`${dateStr}T00:00:00`);
  d.setDate(d.getDate() + delta);
  return [d.getFullYear(), String(d.getMonth() + 1).padStart(2, "0"), String(d.getDate()).padStart(2, "0")].join("-");
};

const dayLabel = (dateStr) => {
  const d = new Date(`${dateStr}T00:00:00`);
  return d.toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
};

export default function DayNav({ date, onChange }) {
  return (
    <div className="daynav">
      <button type="button" className="btn btn-sm" onClick={() => onChange(shiftDay(date, -1))}>‹</button>
      <div className="daynav__date">{dayLabel(date)}</div>
      <button type="button" className="btn btn-sm" onClick={() => onChange(shiftDay(date, 1))}>›</button>
      <button type="button" className="btn btn-sm" onClick={() => onChange(today())}>Hari Ini</button>
      <input type="date" className="form-input" style={{ width: 150 }} value={date}
        onChange={(e) => onChange(e.target.value)} />
    </div>
  );
}
